<dialog-draggable-header>Add Tool Relationship for Selected Part</dialog-draggable-header>

<mat-dialog-content>
  <form [formGroup]="addToolRelationForm">
    <div>
      <searchable-autocomplete [options]="tools" [exactMatch]="true" formControlName="tool" filterBy="toolNo"
        label="Tool:" >
      </searchable-autocomplete>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" (keypress.enter)="save()" (click)="save()">Save</button>
  <button mat-raised-button (keypress.enter)="close()" (click)="close()">Cancel</button>
</mat-dialog-actions>